import {BmoForm} from 'common/types/store/bmoTypes';

export const MIME_TYPE = {
	PNG: 'image/png',
	JPEG: 'image/jpeg',
};

export const FILES_LIMIT = 3;
export const MAX_FILE_SIZE = 10000000;

export async function blobToBase64(blob: Blob | null): Promise<string> {
	return new Promise((resolve, reject) => {
		if (blob) {
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = () => {
				resolve(reader.result as string);
			};
		} else reject(new Error('No blob specified'));
	});
}

export function fileSizeToMB(sizeInKB: number): string {
	return (sizeInKB / (1024 * 1024)).toFixed(2);
}

export function formatFileSize(bytes: number): string {
	if (!bytes) return '';
	const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
	if (bytes === 0) return '0 byte';
	// const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	const i = Math.floor(Math.log(bytes) / Math.log(1000));
	// return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
	return (bytes / Math.pow(1000, i)).toFixed(2) + ' ' + sizes[i];
}

export function convertMB(mb: number | null): {valueInMB: number; valueInString: string} {
	if (!mb) return {valueInMB: 0, valueInString: ''};
	const bytes = mb * 1000 * 1000;
	const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1000)), sizes.length - 1);
	const valueInString = Math.round(bytes / Math.pow(1000, i)) + ' ' + sizes[i];

	return {valueInMB: mb, valueInString};
}

function appendFormData(formData: FormData, data: Record<string, unknown>, parentKey = '') {
	for (const key in data) {
		if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
		const value = data[key];
		const formKey = parentKey ? `${parentKey}.${key}` : key;

		if (value instanceof File) {
			formData.append(formKey, value);
		} else if (Array.isArray(value)) {
			// Special case for notificationEmails: append each as its own field
			if (formKey === 'notificationEmails') {
				value.forEach((item) => {
					formData.append(formKey, item ?? '');
				});
			} else {
				value.forEach((item, idx) => {
					if (item instanceof File) {
						formData.append(formKey, item);
					} else {
						formData.append(`${formKey}[${idx}]`, item ?? '');
					}
				});
			}
		} else if (typeof value === 'object' && value !== null) {
			appendFormData(formData, value as Record<string, unknown>, formKey);
		} else if (value !== undefined && value !== null) {
			formData.append(formKey, String(value));
		}
	}
}


export function createFormData(form: BmoForm): FormData {
	const formData = new FormData();

	// Handle files separately if needed
	if (form.files && form.files.length > 0) {
		form.files.forEach((file) => formData.append('files', file));
	}

	// Remove files from the object before appending the rest
	const rest = {...form};
	delete rest.files;
	appendFormData(formData, rest);

	return formData;
}
